import endpoints from "hooks/api/endpoints";
import useApiGet from "hooks/api/useApiGet";
import useProjectId from "hooks/ProjectScope";
import Participant from "models/Participant";
import IndividualItemResponse from "types/IndividualItemResponse";
import ParticipantDto from "types/ParticipantDto";

export default function useGetParticipantById(
  participantId: string | undefined | null,
) {
  const projectId = useProjectId();
  const { result, ...rest } = useApiGet<IndividualItemResponse<ParticipantDto>>(
    participantId ? endpoints.getParticipantById(projectId, participantId) : "",
  );

  return {
    participant: result?.data ? new Participant(result.data) : undefined,
    ...rest,
  };
}
